import { t as e } from "./createLucideIcon-CJLgHpqc.js";
var t = e("search", [["path", {
	d: "m21 21-4.34-4.34",
	key: "14j7rj"
}], ["circle", {
	cx: "11",
	cy: "11",
	r: "8",
	key: "4ej97u"
}]]);
//#endregion
export { t };

//# sourceMappingURL=search-Chd7o8f1.js.map